<template>
<div>
    <h1 class="documentTitle" v-touch:touchhold="togglePresentationMode">
      시리얼 번호로 기기 조회하기
    </h1>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-if="this.did == null">
      시리얼 번호 {{serial}}를 조회 중입니다.
    </b-alert>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-else-if="this.did == -1">
      시리얼 번호 {{serial}}는 잘못된 시리얼 번호입니다.
    </b-alert>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-else-if="this.did == -2">
      시리얼 번호 {{serial}}로 등록된 기기는 없습니다.
    </b-alert>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-else-if="this.did == -3">
      시리얼 번호 조회중 에러가 발생했습니다(-3).
    </b-alert>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-else-if="this.did == -4">
      시리얼 번호 조회중 에러가 발생했습니다(-4).
    </b-alert>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-else-if="this.did == -5">
      시리얼 번호 조회중 에러가 발생했습니다(-5).
    </b-alert>
    <b-alert class="mb-2 mt-4 ml-4 mr-4 p-2 fontSizeDot9" show variant="danger" v-else-if="this.did == -6">
      시리얼 번호 조회중 에러가 발생했습니다(-6).
    </b-alert>
    <div v-else>
      <div class="mb-4 mt-4 ml-4 mr-4 p-2 fontSize2 text-center">
        &gt;&gt;&gt;
        <router-link :to="{ name: 'tinkDevice', params: { did: this.did }}" custom v-slot="{ navigate }">
          <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
            <b>{{did}}</b> 기기로 이동하기
          </span>  
        </router-link>
        &lt;&lt;&lt;
      </div>
    </div>
    <div class="mb-4 mt-1 ml-3 mr-3 p-2">
      <b-form @submit.stop.prevent class="was-validated">
        <b-input-group class="mt-2">
          <b-input-group-text slot="prepend" style="width : 100px;">
            <label for="newSerial" style="margin-bottom : 0rem">시리얼 번호</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop id="newSerial" v-model="newSerial" required title="기기의 시리얼번호는 영문대소문자로 되어있습니다.
          AAAA-AAAA-AAAA-AAAA와 같은 형식입니다. 대소문자는 구별합니다."
          pattern="^[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}$" minlength="19" maxlength="19"
          v-on:keyup="this.enterKeyChecker"
          data-nextfocus="newSerialButton"
          trim/>
          <b-input-group-append>
          <b-button size="sm" id="newSerialButton" variant="primary" @click="queryNewSerial()">
            조회하기
          </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form>
    </div>
</div>
</template>
<script>

import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"
import uiUtil from "@/mixins/util.js"

export default {
  name: "tinkDeviceBySerial",
  mixins: [user, functions, uiUtil],
  data : function() {
    return {
      did: null,
      newSerial: ""
    }
  },
  props: {
    serial: String
  },
  mounted: function() {
    this.newSerial = this.serial;
    this.getDevice();
  },
  methods: {
    queryNewSerial: function(evt) {
      if(!window.document.getElementById('newSerial').checkValidity()) {
        window.document.getElementById('newSerial').reportValidity();
        return false;
      }
      else {
        if(this.newSerial != this.serial) {
          this.did = null;
          this.$router.replace({ path: '/dbs/' + this.newSerial });
          this.getDevice();
        }
      }
    },

    getDevice: function() {
      if(typeof(this.newSerial) == "undefined" || this.newSerial == "") {
        this.did = -3;
      }
      this.get(this.functionsServer + "/app/dbs?serial=" + this.newSerial)
      .then(result=> {
        if(result.status != 200) {
          this.did =  -4;
        }
        else {
          if(result.headers["content-type"].indexOf("text/plain") != -1) {
            if(result.data == "-1") {
              this.did =  -1;
            }
            else if(result.data == "-2") {
              this.did =  -2;
            }
            else {
              this.did = result.data;
              // setTimeout(()=> {
              //   this.$router.push({ name: 'tinkDevice', params: { did: this.did }});
              // }, 1000);
            }
          }
          else {
            this.did = -5;
          }
        }
      })
      .catch(error => {
        console.log(error);
        this.did = -6;
      })
    }
  }
}
</script>
